import { h, Host } from "@stencil/core";
import { configureSlider } from "../abstract-uvex-slider/configure-slider";
export class SliderProduct {
    componentDidLoad() {
        this.swiper = configureSlider(this.el, {
            loop: false,
            pagination: false,
            slidesPerView: 2,
            slidesPerGroup: 2,
            breakpoints: {
                543: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                767: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                991: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1199: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
            },
        });
    }
    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy();
        }
    }
    render() {
        return h(Host, { key: '7dafb42ca0fd735c7a0e8aa54acc57f65b76a5a3', class: "carousel" }, h("div", { key: '866640c6f218404574903c214406ac821d7bcfe1', class: "carousel-inner" }, h("slot", { key: 'ef1e1579ee2650c0e4044c4d042b59b705869343' })), h("a", { key: 'f80ff03ed02aa8d9789b0484723a83e74a688522', class: "carousel-control carousel-control-left small invert left", role: "button" }), h("a", { key: '69fe67d4ba22f6241fd7f1f1fb1b865283a78578', class: "carousel-control carousel-control-right small invert right", role: "button" }));
    }
    static get is() { return "uvex-slider-product"; }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=slider-product.js.map
